userProfileSwitchInProgress